import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteCategoryRes;
export const DeleteCategoryTodo = createAsyncThunk('AddCategory', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `vehicle_category/${id}`,
          
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteCategoryRes = res.data
        
    } catch (error) {
        return DeleteCategoryRes = error.response.data
    }
})
